var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.117 37.2891C395.379 24.0523 455.875 24.1072 514.113 37.4497C572.351 50.7924 626.836 77.08 673.525 114.361L425.263 425.264L337.117 37.2891Z",
    fill: "url(#paint0_linear_61_19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0613 252.102C93.065 198.311 130.85 151.067 177.611 113.877C224.372 76.6866 278.909 50.5055 337.173 37.2768L425.264 425.264L67.0613 252.102Z",
    fill: "url(#paint1_linear_61_19)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.958C823.023 485.705 809.464 544.662 783.456 598.451C757.449 652.241 719.661 699.482 672.897 736.669L425.265 425.264L823.127 425.958Z",
    fill: "url(#paint2_linear_61_19)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M673.482 114.326C720.176 151.601 757.875 198.914 783.781 252.752C809.687 306.591 823.135 365.572 823.127 425.319L425.264 425.264L673.482 114.326Z",
    fill: "url(#paint3_linear_61_19)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M672.395 737.066C625.572 774.178 570.991 800.268 512.705 813.399C454.419 826.53 393.924 826.365 335.71 812.917L425.264 425.264L672.395 737.066Z",
    fill: "url(#paint4_linear_61_19)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4594 597.175C40.6436 543.294 27.2944 484.289 27.4029 424.543C27.5114 364.796 41.0746 305.84 67.0858 252.053L425.265 425.265L66.4594 597.175Z",
    fill: "url(#paint5_linear_61_19)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M335.766 812.929C277.55 799.489 223.109 773.11 176.483 735.75C129.857 698.391 92.2444 651.01 66.4361 597.124L425.265 425.264L335.766 812.929Z",
    fill: "url(#paint6_linear_61_19)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_19",
    x1: 338.736,
    y1: 192.429,
    x2: 565.667,
    y2: 165.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_19",
    x1: 189.316,
    y1: 347.625,
    x2: 424.776,
    y2: 96.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_19",
    x1: 676.431,
    y1: 416.798,
    x2: 602.569,
    y2: 634.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_19",
    x1: 574.993,
    y1: 223.43,
    x2: 769.776,
    y2: 546.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_61_19",
    x1: 603.901,
    y1: 597.856,
    x2: 410.75,
    y2: 719.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9176DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_61_19",
    x1: 217.385,
    y1: 561.226,
    x2: 141.151,
    y2: 345.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_61_19",
    x1: 394.718,
    y1: 666.732,
    x2: 98.7764,
    y2: 493.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors7);
export default __webpack_public_path__ + "static/media/sectors-7.0279166b1aea4114176205d986a5e255.svg";
export { ForwardRef as ReactComponent };